import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
    FiHome,
    FiCalendar,
    FiShoppingCart,
    FiDollarSign,
    FiGrid,
    FiX,
    FiBox,
    FiImage,
} from 'react-icons/fi';
import './Sidebar.css';

const Sidebar = ({ isOpen, toggleSidebar }) => {
    const location = useLocation();

    const isActive = (path) => location.pathname === path;

    // Helper to close the sidebar on navigation, but only if it's currently showing as a drawer (mobile)
    const handleNavClick = () => {
        if (window.innerWidth <= 768 && isOpen) {
            toggleSidebar();
        }
    };

    return (
        <>
            {isOpen && <div className="sidebar-overlay active" onClick={toggleSidebar} />}
            <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
                <button className="close-btn" onClick={toggleSidebar}>
                    <FiX size={24} />
                </button>

                <nav className="sidebar-nav">
                    <Link to="/dashboard" className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`} onClick={handleNavClick}>
                        <FiHome size={20} />
                        <span>Dashboard</span>
                    </Link>

                    <Link to="/events" className={`nav-link ${isActive('/events') ? 'active' : ''}`} onClick={handleNavClick}>
                        <FiCalendar size={20} />
                        <span>Events</span>
                    </Link>

                    <Link to="/orders" className={`nav-link ${isActive('/orders') ? 'active' : ''}`} onClick={handleNavClick}>
                        <FiShoppingCart size={20} />
                        <span>Orders</span>
                    </Link>

                    <Link to="/payments" className={`nav-link ${isActive('/payments') ? 'active' : ''}`} onClick={handleNavClick}>
                        <FiDollarSign size={20} />
                        <span>Payments</span>
                    </Link>

                    <Link to="/categories" className={`nav-link ${isActive('/categories') ? 'active' : ''}`} onClick={handleNavClick}>
                        <FiGrid size={20} />
                        <span>Categories</span>
                    </Link>

                    <Link to="/services" className={`nav-link ${isActive('/services') ? 'active' : ''}`} onClick={handleNavClick}>
                        <FiBox size={20} />
                        <span>Services</span>
                    </Link>


                    <Link to="/advertisements" className={`nav-link ${isActive('/advertisements') ? 'active' : ''}`} onClick={handleNavClick}>
                        <FiImage size={20} />
                        <span>Advertisements</span>
                    </Link>
                </nav>
            </aside>
        </>
    );
};

export default Sidebar;